import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, lazy } from "react";
import { useNavigate } from "react-router-dom";
import AppSidebarLayout from "../../components/AppSidebarLayout";
// Item 40: creating a new proposal reuses the exact same anonymous flow, not a separate
// implementation -- same federated remote/lazy pattern HomePage.tsx already uses.
const RemoteDiscoveryFlow = lazy(() => import("@coremind/client-proposals-ui").then((mod) => ({ default: mod.DiscoveryFlow })));
export default function ProposalsNewPage() {
    const navigate = useNavigate();
    return (_jsx(AppSidebarLayout, { defaultCollapsed: true, children: _jsx(Suspense, { fallback: null, children: _jsx(RemoteDiscoveryFlow, { variant: "embedded", onConversationId: (id) => navigate(`/app/proposals/${id}`, { replace: true }) }) }) }));
}
